import { render, staticRenderFns } from "./dropzones.vue?vue&type=template&id=50e11fe4"
import script from "./dropzones.js?vue&type=script&lang=js&external"
export * from "./dropzones.js?vue&type=script&lang=js&external"
import style0 from "./dropzones.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports